import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  private progressSubject = new BehaviorSubject<number>(null);
  loading$ = this.loadingSubject.asObservable();  // Expose as an observable
  progress$ = this.progressSubject.asObservable();
  constructor() {}

  setLoading(loading: boolean) {
    // this.progressSubject.next(loading ? 0 : null);
    this.loadingSubject.next(loading);
    if(!loading){
      this.setProgress(null);
    }
  }

  setProgress(progress: number){
    this.progressSubject.next(progress);
  }

  getProgress(){
    return this.progress$;
  }

  getLoading() {
    return this.loading$;  // Return observable
  }
}
